const { useI18n } = require('@fegobull/webapi').use;
import { ELang } from '@ark/utils';
const $t = useI18n({
  [ELang.KV.CN]: {
    // 已浏览标签
    ViewedBadge: {
      text: '已浏览',
    },
    // 日期格式
    DateFormat: {
      // {month}月{day}日更新
      updateTemplate: '{month}月{day}日更新',
    },
  },
  [ELang.KV.EN]: {
    // 已浏览标签
    ViewedBadge: {
      text: 'Viewed',
    },
    // 日期格式
    DateFormat: {
      // Updated on {month}/{day}
      updateTemplate: 'Updated on {month}/{day}',
    },
  },
});

export default $t;
